export default "__VITE_ASSET__BfGF9YfU__"